module.exports = __webpack_public_path__ + "static/media/password_icon.707d136a.svg";